var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseOwn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "houseOwn-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-25.3 1)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "houseOwn",
    transform: "translate(25.3 -1)",
    clipPath: "url(#houseOwn-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.951,6.071,39.355,2,29.7,6.071",
    transform: "translate(-12.579)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5,12.9V23.136H48.331V12.9",
    transform: "translate(-14.161 -4.758)",
    fill: "none",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5,12.9V23.136H48.331V12.9",
    transform: "translate(-14.161 -4.758)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.277,34.445l4.847.116v.407l-.058,2.908,2.6-1.28H9.72a9.964,9.964,0,0,1,8.655,0l.635.291a8.161,8.161,0,0,0,3.462.814l6.116.174a3.682,3.682,0,0,1,3.116,1.8l.808,1.338,1.442-.64,5.077-2.21v.058l1.558-.756a2.566,2.566,0,0,1,1.154-.233,3.406,3.406,0,0,1,1.5.407L29.222,46.019a10.154,10.154,0,0,1-3.981.814,10.542,10.542,0,0,1-1.9-.174L12.951,43.925a4.466,4.466,0,0,0-1.269-.174,4.866,4.866,0,0,0-2.193.523l-1.731.872-.923.465v.756l-4.847-.116.288-11.807M1.412,32.7a.78.78,0,0,0-.808.756L.2,47.182a.78.78,0,0,0,.808.756l6.693.174h0a.78.78,0,0,0,.808-.756h0v-.64h0l1.731-.872a3.108,3.108,0,0,1,1.442-.349,3.38,3.38,0,0,1,.808.116l10.386,2.734h.058a9.861,9.861,0,0,0,2.25.233h0a12.64,12.64,0,0,0,4.674-.931h0c.058,0,.058-.058.115-.058h0l15.117-9.131a.765.765,0,0,0,.288-.989h0a4.275,4.275,0,0,0-3.693-2.036,4.5,4.5,0,0,0-1.9.407h0l-6.635,2.908h0a5.453,5.453,0,0,0-4.558-2.617h0l-6.116-.174h0a5.762,5.762,0,0,1-2.77-.7h0l-.635-.291h0a11.617,11.617,0,0,0-5.077-1.163,12,12,0,0,0-5.077,1.163H8.855V34.91l.058-1.338a.78.78,0,0,0-.808-.756L1.412,32.7Z",
    transform: "translate(0 -13.578)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79,45.6h0a6.321,6.321,0,0,1,.058,1.047.784.784,0,0,1-.814.756h0l-10.12-.233a.784.784,0,0,1-.814-.756.839.839,0,0,1,.872-.756l9.189.174h.058v-.058",
    transform: "translate(-16.093 -18.824)",
    strokeWidth: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseOwn);
export default __webpack_public_path__ + "static/media/houseOwn.0ce796c588451e3045c297586afcff5b.svg";
export { ForwardRef as ReactComponent };